<template>
  <div>
    <div class="row">
      <div class="col-lg-12" v-show="true">
        <block-cntr
          :btitle="'ONT Profile Configuration'"
          style="height: 100%"
          :closeButton="false"
        >
          <form class="form-horizontal">
            <div
              class="form-group"
              v-for="(value, key, index) in ontProfile"
              :key="index"
            >
              <div class="col-lg-12">
                <label>{{ value.config }}</label>
              </div>
            </div>
          </form>
        </block-cntr>
      </div>
    </div>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "@/components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "ontProfileConfiguration",
  data() {
    return {
      ontProfile: "",
    }
  },
  props: ["ontIndex"],
  components: {
    BlockCntr,
  },
  created() {
    this.loadOntProfile()
  },
  methods: {
    loadOntProfile() {
      get("ontProfileConfig?ontIndex=" + this.ontIndex)
        .then((res) => {
          this.ontProfile = res.data
        })
        .catch((err) => {
          //this.ontProfile = en.ontProfile
        })
    },
  },
}
</script>